export enum PaymentTermCountKind {
	PERCENTAGE = 'P',
	VALUE = 'V',
	REMAINING_TO_THE_GIVEN_PERCENTAGE = 'R',
}
